import React, { useState } from "react";
import style from "./Details.module.scss";
import CaretDown24 from "../../../../assets/svg/icons/common/CaretDown24";
import HeadingWithLine from "../../../../components/HeadingWithLine/HeadingWithLine";
import moment from "moment";

function PersonalInformation({ appData, expandAppDetails }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={`${style.accordion_item} ${expandAppDetails ? style.expanded : ""}`}
    >
      <div
        className={`${style.accordion_head} ${isOpen ? style.open : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <CaretDown24 />
        <h5>Personal Information</h5>
      </div>
      {isOpen && (
        <>
          <div className={style.accordion_body}>
            <div className={style.data_item}>
              <p className={style.data_label}>Name</p>
              <p className={style.data_value}>
                {appData?.field_firstname || "-"}{" "}
                {appData?.field_lastname || "-"}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Personal Phone</p>
              <p className={style.data_value}>
                {appData?.field_personalphone || "-"}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Personal Email</p>
              <p className={style.data_value}>{appData?.email || "-"}</p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Personal Street Address</p>
              <p className={style.data_value}>
                {appData?.field_personalstreet || "-"}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>DBA City</p>
              <p className={style.data_value}>
                {appData?.field_personalcity || "-"}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>DBA State</p>
              <p className={style.data_value}>
                {appData?.field_personalstate || "-"}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>DBA Zip</p>
              <p className={style.data_value}>
                {appData?.field_personalzip || "-"}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Period of Residence</p>
              <p className={style.data_value}>
                {appData?.field_residenceyears || "0"} Years{" "}
                {appData?.field_residencemonths || "0"} Months
              </p>
            </div>
          </div>

          <HeadingWithLine
            text={"Identity document"}
            className={style.heading_line}
          />
          <div className={style.accordion_body}>
            <div className={style.data_item}>
              <p className={style.data_label}>ID Type</p>
              <p className={style.data_value}>
                {appData?.field_documenttype || "-"}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>ID Number</p>
              <p className={style.data_value}>
                {appData?.field_documentnumber || "-"}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Social Security Number</p>
              <p className={style.data_value}>
                {appData?.field_socialsecurity || "-"}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Date of Birth</p>
              <p className={style.data_value}>
                {moment(appData?.field_birthdate).format("MM/D/YYYY") || "-"}
              </p>
            </div>
          </div>

          <HeadingWithLine text={"Ownership"} className={style.heading_line} />
          <div className={style.accordion_body}>
            <div className={style.data_item}>
              <p className={style.data_label}>Percentage of ownership</p>
              <p className={style.data_value}>
                {appData?.field_ownershippercentage || "-"}%
              </p>
            </div>
          </div>

          {/*Additional Signers*/}
          {appData?.signers?.map((signer, index) => {
            return (
              <div key={index}>
                <h5 className={style.heading}>Additional owner #{index + 2}</h5>
                <div className={style.accordion_body}>
                  <div className={style.data_item}>
                    <p className={style.data_label}>Name</p>
                    <p className={style.data_value}>
                      {signer?.first_name || "-"} {signer?.last_name || "-"}
                    </p>
                  </div>
                  <div className={style.data_item}>
                    <p className={style.data_label}>Personal Phone</p>
                    <p className={style.data_value}>{signer?.phone || "-"}</p>
                  </div>
                  <div className={style.data_item}>
                    <p className={style.data_label}>Personal Email</p>
                    <p className={style.data_value}>{signer?.email || "-"}</p>
                  </div>
                  <div className={style.data_item}>
                    <p className={style.data_label}>Personal Street Address</p>
                    <p className={style.data_value}>
                      {signer?.address_street || "-"}
                    </p>
                  </div>
                  <div className={style.data_item}>
                    <p className={style.data_label}>DBA City</p>
                    <p className={style.data_value}>
                      {signer?.address_city || "-"}
                    </p>
                  </div>
                  <div className={style.data_item}>
                    <p className={style.data_label}>DBA State</p>
                    <p className={style.data_value}>
                      {signer?.address_state || "-"}
                    </p>
                  </div>
                  <div className={style.data_item}>
                    <p className={style.data_label}>DBA Zip</p>
                    <p className={style.data_value}>
                      {signer?.address_zip_code || "-"}
                    </p>
                  </div>
                  <div className={style.data_item}>
                    <p className={style.data_label}>Period of Residence</p>
                    <p className={style.data_value}>
                      {signer?.residence_years || "0"} Years{" "}
                      {signer?.residence_months || "0"} Months
                    </p>
                  </div>
                </div>

                <HeadingWithLine
                  text={"Identity document"}
                  className={style.heading_line}
                />
                <div className={style.accordion_body}>
                  <div className={style.data_item}>
                    <p className={style.data_label}>ID Type</p>
                    <p className={style.data_value}>
                      {signer?.document_type || "-"}
                    </p>
                  </div>
                  <div className={style.data_item}>
                    <p className={style.data_label}>ID Number</p>
                    <p className={style.data_value}>
                      {signer?.drivers_license_number || "-"}
                    </p>
                  </div>
                  <div className={style.data_item}>
                    <p className={style.data_label}>Social Security Number</p>
                    <p className={style.data_value}>
                      {signer?.social_security || "-"}
                    </p>
                  </div>
                  <div className={style.data_item}>
                    <p className={style.data_label}>Date of Birth</p>
                    <p className={style.data_value}>
                      {moment(signer?.date_of_birth).format("MM/D/YYYY") || "-"}
                    </p>
                  </div>
                </div>

                <HeadingWithLine
                  text={"Ownership"}
                  className={style.heading_line}
                />
                <div className={style.accordion_body}>
                  <div className={style.data_item}>
                    <p className={style.data_label}>Percentage of ownership</p>
                    <p className={style.data_value}>
                      {signer?.ownership_percentage || "-"}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </>
      )}
    </div>
  );
}

export default PersonalInformation;
